"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _router = _interopRequireDefault(require("./router"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _elementUi = require("element-ui");
var _admin = require("@/store/modules/admin");
var _permission = require("@/store/modules/permission");
var _lang = _interopRequireDefault(require("@/lang"));
var _settings = _interopRequireDefault(require("./settings"));
var _settings2 = require("./api/settings");
// Internationalization

_nprogress.default.configure({
  showSpinner: false
});
const whiteList = ['/login', '/agent-login', '/admin-login-otp', '/admin-verify-otp', '/recover-password', '/auth-redirect', '/reset-password/1a7dbabf-06a8-47bb-a907-03a21413585a', '/account-delete'];
let versionCheckShown = false;
const getPageTitle = key => {
  const hasKey = _lang.default.te(`route.${key}`);
  if (hasKey) {
    const pageName = _lang.default.t(`route.${key}`);
    return `${pageName} - ${_settings.default.title}`;
  }
  return `${_settings.default.title}`;
};
const handleVersionMismatch = latestVersion => {
  if (versionCheckShown) return;
  versionCheckShown = true;
  _elementUi.MessageBox.confirm('A new version of the application is available. Please refresh to get the latest updates.', 'New Version Available', {
    confirmButtonText: 'Refresh',
    cancelButtonText: 'Cancel',
    type: 'warning',
    closeOnClickModal: false,
    closeOnPressEscape: false,
    showClose: false
  }).then(() => {
    // Store the version user has acknowledged (shared across all tabs)
    localStorage.setItem('versionCheckDone', latestVersion);
    // Fire-and-forget cache clear (no async/await)
    if (window.caches) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    // Force hard reload bypassing cache
    window.location.reload();
  }).catch(() => {
    // User clicked cancel
    versionCheckShown = false;
    console.log('User cancelled refresh');
  });
};
_router.default.beforeEach(async (to, _, next) => {
  // Start progress bar
  _nprogress.default.start();
  // Determine whether the user has logged in
  if (_admin.AdminModule.token) {
    if (to.path === '/login') {
      // If is logged in, redirect to the home page
      next({
        path: '/'
      });
      _nprogress.default.done();
    } else {
      var _AdminModule$roles;
      // Check whether the user has obtained his permission roles
      if (((_AdminModule$roles = _admin.AdminModule.roles) === null || _AdminModule$roles === void 0 ? void 0 : _AdminModule$roles.length) === 0) {
        try {
          // Get user info
          await _admin.AdminModule.GetAdminInfo();
          const roles = _admin.AdminModule.roles;
          // settings api call (async)
          const settingsData = await (0, _settings2.getSettingById)(1);
          if (settingsData.webVersion !== process.env.VUE_APP_VERSION) {
            const dismissedVersion = localStorage.getItem('versionCheckDone');
            // Only show popup if THIS version hasn’t been dismissed yet
            if (dismissedVersion !== settingsData.webVersion) {
              handleVersionMismatch(settingsData.webVersion);
              return; // Stop further navigation
            }
          } else {
            // Versions match, clear any old flag
            localStorage.removeItem('versionCheckDone');
          }
          // Generate accessible routes map based on role
          _permission.PermissionModule.GenerateRoutes(roles);
          // Dynamically add accessible routes
          _router.default.addRoutes(_permission.PermissionModule.dynamicRoutes);
          // Hack: ensure addRoutes is complete
          next({
            ...to,
            replace: true
          });
        } catch (err) {
          // Remove token and redirect to login page
          _admin.AdminModule.ResetToken();
          _elementUi.Message.error(err.toString() || 'Has Error');
          next(`/login?redirect=${to.path}`);
          _nprogress.default.done();
        }
      } else {
        next();
      }
    }
  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      if (to.path === '/recover-password') {
        next('/recover-password');
      } else if (to.path === '/reset-password/1a7dbabf-06a8-47bb-a907-03a21413585a') {
        next('/reset-password/1a7dbabf-06a8-47bb-a907-03a21413585a');
      }
      next(`/login?redirect=${to.path}`);
      _nprogress.default.done();
    }
  }
});
_router.default.afterEach(to => {
  // Finish progress bar
  _nprogress.default.done();
  // set page title
  document.title = getPageTitle(to.meta.title);
});